<template>
    <div class="mt">
        <div v-if="customer && summarize" class="mt-2">
            <span>{{ customer.full_name }}</span> <br />
            <span>{{ customer.email }}</span
            ><br />
            <span>{{ customer.phone }}</span>

            <div
                v-if="allowChangeAuth"
                class="border border-2 border-solid border-default-2 px mt-2"
            >
                <h5><i class="icon-cr icon-lightning"></i> Compra rápida</h5>
                <p>
                    Identificamos seus dados a partir de compras anteriores. Facilitaremos sua
                    compra preenchendo alguns dados de forma segura, caso queira visualizar os dados
                    completos é só
                    <strong
                        ><a href="#" @click.prevent.stop="forceLogin"
                            >clicar aqui e fazer login</a
                        ></strong
                    >.
                </p>
            </div>
        </div>
        <div v-else>
            <p ref="alertAnchor">Para continuar a compra, insira seu e-mail abaixo</p>
            <form @submit.prevent="fastAuthenticate">
                <div class="row">
                    <div class="col-sm-9 mb-2">
                        <TextField
                            v-model="fastLoginEmail"
                            :error.sync="fastLoginEmailError"
                            autocomplete="email"
                            autofocus
                            name="email"
                            placeholder="E-mail"
                            type="email"
                            :disabled="authenticationStatus !== AUTH_OK_STATE"
                            @blur="validateEmail"
                        />
                    </div>
                    <div class="col-sm-3" v-if="authenticationStatus === AUTH_OK_STATE">
                        <LoadingButton
                            :loading="isBusy"
                            class="btn btn-md full-size"
                            :class="{ 'mt-3': $scope.mobile_version }"
                            @click="fastAuthenticate"
                        >
                            Entrar
                            <span
                                ><i class="animation-go-back icon-cr icon-arrow-right ml-2"></i
                            ></span>
                        </LoadingButton>
                    </div>
                    <div class="col-sm-3" v-else>
                        <button class="btn btn-md btn-light full-size" @click.prevent="resetState">
                            Alterar
                        </button>
                    </div>
                </div>
            </form>
            <div
                class="mt-2"
                v-if="
                    authenticationStatus === AUTH_NEED_LOGIN ||
                    authenticationStatus === AUTH_NEED_LOGIN_TO_EDIT
                "
            >
                <p v-if="authenticationStatus === AUTH_NEED_LOGIN_TO_EDIT">
                    É necessário digitar sua senha para visualizar/editar seus dados:
                </p>
                <p v-else>Digite sua senha para continuar o checkout:</p>
                <form @submit.prevent="fastLogin">
                    <div class="row">
                        <div class="col-sm-9 mb-2">
                            <TextField
                                v-model="fastPassword"
                                :error.sync="fastPasswordError"
                                autocomplete="password"
                                autofocus
                                name="password"
                                placeholder="Senha"
                                type="password"
                            />
                        </div>
                        <div class="col-sm-3">
                            <LoadingButton
                                :loading="loading"
                                class="btn btn-md full-size"
                                @click="fastLogin"
                            >
                                Entrar
                                <span
                                    ><i class="animation-go-back icon-cr icon-arrow-right ml-2"></i
                                ></span>
                            </LoadingButton>
                        </div>
                    </div>
                </form>
                <a
                    class="text-underline"
                    :href="`${$scope.URL_STORE_PREFIX}/recuperar-senha`"
                    target="_blank"
                >
                    Esqueceu sua senha?
                </a>
            </div>
            <div
                class="row"
                v-if="
                    allowSocialLogin &&
                    (authenticationStatus === AUTH_OK_STATE ||
                        authenticationStatus === AUTH_NEED_LOGIN ||
                        authenticationStatus === AUTH_NEED_LOGIN_TO_EDIT)
                "
            >
                <div class="col-sm-12 mt">
                    <div class="d-flex flex-grid">
                        <div class="mt flex-xs-5 flex-sm-5 flex-md-5 flex-lg-5">
                            <span class="flex-child-fixed">Ou acesse sua conta com:</span>
                        </div>
                        <div class="flex-xs-1 flex-sm-1 flex-md-1 flex-lg-1">
                            <div
                                id="g_id_onload"
                                data-client_id="316338802025-ck2s8vosc6arsqg34hb272nl7c6q99d8.apps.googleusercontent.com"
                                data-context="signin"
                                data-ux_mode="popup"
                                data-callback="onGoogleSignIn"
                                data-nonce=""
                                data-auto_prompt="false"
                            ></div>

                            <div
                                class="g_id_signin"
                                data-type="icon"
                                data-shape="square"
                                data-theme="outline"
                                data-text="signin_with"
                                data-size="large"
                            ></div>
                        </div>
                        <div class="flex-xs-1 flex-sm-1 flex-md-1 flex-lg-1 ml-3">
                            <span class="facebook-login text-center" @click="fbLogin">
                                <div class="facebook-icon">
                                    <img
                                        data-src="https://chico-rei.imgix.net/icones/icon-facebook.jpg"
                                    />
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="authenticationStatus === AUTH_NEW_ACCOUNT">
                <p>Complete seus dados:</p>
                <Alert :alert="alert" />

                <CustomerForm
                    :is-fast-sing-up="true"
                    :fast-sing-up-mail="fastLoginEmail"
                    :api-errors="registerApiErrors"
                    :class="{ busy: loading }"
                    v-model="fastCustomer"
                    @done="submitRegister"
                    @error="showError"
                />
            </template>
        </div>
    </div>
</template>

<script>
    import BaseCheckoutAuthentication from './common/BaseCheckoutAuthentication.vue';

    export default {
        name: 'CheckoutAuthentication',
        extends: BaseCheckoutAuthentication,
    };
</script>
